module.exports = __webpack_public_path__ + "img/3.2ac2fca8.jpg";